import React from 'react'
import { Avatar, Stack, Tooltip, Typography } from '@mui/material'
import { initials } from './helpers'

// The CRM user who owns a lead. `owner` is the server's shapeCRMUser
// ({ _id, name, photograph }) or null for unassigned. `showName` adds the
// name beside the avatar (list view / lead page); otherwise it is a bare
// avatar with a tooltip (board cards).
const OwnerAvatar = ({ owner, size = 22, showName = false, isMe = false }) => {
  const label = owner ? `${owner.name}${isMe ? ' (you)' : ''}` : 'Unassigned'
  const avatar = (
    <Avatar
      src={owner?.photograph || undefined}
      sx={{
        width: size,
        height: size,
        fontSize: size * 0.45,
        fontWeight: 700,
        bgcolor: owner ? '#0F4C5C' : '#E2E8F0',
        color: owner ? '#FFFFFF' : '#64748B',
      }}
    >
      {owner ? initials(owner.name) : '?'}
    </Avatar>
  )
  if (!showName) {
    return (
      <Tooltip title={owner ? `Owner: ${label}` : 'No owner'}>
        {avatar}
      </Tooltip>
    )
  }
  return (
    <Stack direction="row" gap={0.75} alignItems="center" minWidth={0}>
      {avatar}
      <Typography variant="body2" color={owner ? 'text.primary' : 'text.disabled'} noWrap>
        {label}
      </Typography>
    </Stack>
  )
}

export default OwnerAvatar
